const defaultTimeZone = 'America/New_York';

export default defaultTimeZone;
